<template>
  <div>
    <div class="row my-4">
      <div class="col-8">
        <TemplateDetailsHeader
          title="Template Details"
          :is-link="true"
        />
      </div>
      <div
        v-if="template.template && template.template.id"
        class="col-4 text-right"
      >
        <span class="mr-3">
          <a
            v-if="template.template"
            id="SendToTestEmails"
            href="#"
            @click="onSendTest"
          >
            <font-awesome-icon
              :icon="['far', 'paper-plane']"
              size="lg"
              class="mr-2"
            />Send Test
          </a>
          <span v-else>
            <font-awesome-icon
              :icon="['far', 'paper-plane']"
              size="lg"
              class="mr-2"
            />Send Test
          </span>
        </span>
        <ejs-dropdownbutton
          id="itemActionsDropdown"
          ref="actionsDropdown"
          :items="items"
          css-class="e-caret-hide grid-action px-0"
          :select="onSelect"
          :open="onOpen"
        >
          <button
            id="btnActions"
            class="btn btn-lg btn-primary px-4"
          >
            Actions <font-awesome-icon
              :icon="['far', 'chevron-down']"
              size="xs"
              class="ml-2"
            />
          </button>
        </ejs-dropdownbutton>
        <ejs-toast
          ref="errorToastRefA"
          :position="{ X: 'Right', Y: 'Top' }"
          show-close-button="true"
        />
      </div>
    </div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <router-link
          id="summaryTab"
          class="nav-link"
          :to="{name: 'TemplateDetailsSummary', query: templateQuery }"
          exact-path
        >
          Summary
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          id="previewTab"
          class="nav-link"
          :to="{name: 'TemplateDetailsPreview', query: templateQuery }"
          exact-path
        >
          Preview
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          id="testingTab"
          class="nav-link"
          :to="{name: 'TemplateDetailsTesting', query: templateQuery }"
          exact-path
        >
          Testing
        </router-link>
      </li>
      <li
        v-if="activeType === 'saved'"
        class="nav-item"
      >
        <router-link
          id="campaignsTab"
          class="nav-link"
          :to="{name: 'TemplateDetailsCampaigns', query: templateQuery }"
          exact-path
        >
          Campaigns
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          id="historyTab"
          class="nav-link"
          :to="{name: 'TemplateDetailsHistory', query: templateQuery }"
          exact-path
        >
          History
        </router-link>
      </li>
    </ul>
    <div class="tab-content">
      <router-view />
    </div>
    <BaseDialog
      ref="deleteDialog"
      :content="'Are you sure you wish to delete this template?'"
      :submit-button="deleteButton"
    />
    <BaseDialog
      ref="sendTestDialog"
      title="Send to Test Email(s)"
      width="50%"
      height="60%"
      :force-header="true"
      :custom-content-template="sendTest"
      :show-close-icon="true"
      :on-open="onSendTestDialogOpen"
      :on-close="onSendTestDialogClose"
      :enable-resize="true"
    />
  </div>
</template>

<script>
import TemplateDetailsHeader from '@/components/TemplateDetailsHeader.vue'
import BaseDialog from '@/components/Dialog/BaseDialog'
import { iframeParentCommunication } from '@/mixins/iframeParentCommunication'
import SendTest from '@/components/SendTest/index'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: {
    TemplateDetailsHeader,
    BaseDialog
  },
  mixins: [iframeParentCommunication],
  data () {
    const encodedUrlQuery = this.$helpers.getTemplateBuilderQuery(this.$route, false)
    const unencodedUrlQuery = this.$helpers.getTemplateBuilderQuery(this.$route)
    return {
      encodedUrlQuery,
      unencodedUrlQuery,
      items: [
        { text: 'Edit', id: 'edit' },
        { text: 'Clone', id: 'clone' },
        { text: 'Delete', id: 'delete' }
      ],
      templateQuery: {
        externalId: this.$route.query.externalId,
        clientId: this.$route.query.clientId,
        templateId: this.$route.query.templateId,
        isSearchingTemplate: this.$route.query.isSearchingTemplate,
        userEmail: this.$route.query.userEmail
      },
      deleteButton: {
        label: 'Ok',
        class: 'btn-danger',
        action: this.remove
      },
      sendTest: SendTest
    }
  },
  computed: {
    ...mapState({
      template: state => state.templateBuilder.template.summary,
      userAccessControl: state => state.templateBuilder.userAccessControl
    }),
    ...mapGetters({
      activeType: 'getActiveType'
    })
  },
  mounted () {
    if (!this.userAccessControl.SaveAsResend) {
      this.items = this.items.filter(element => element.id !== 'addResend')
    }
  },
  beforeDestroy () {
    this.$store.commit('RESET_TEMPLATE')
  },
  methods: {
    ...mapActions([
      'uncheckSeedList'
    ]),
    onSelect (args) {
      if (this.template.template.id) {
        if (args.item.text === 'Edit') {
          this.edit()
        } else if (args.item.text === 'Clone') {
          this.clone()
        } else if (args.item.text === 'Delete') {
          this.$refs.deleteDialog.openDialog()
        } else {
          // this.SendMessageToParent(data)
        }
      }
    },
    onOpen (args) {
      args.element.parentElement.style.marginLeft = '-20px'
    },
    onSendTest (e) {
      e.preventDefault()
      this.$store.commit('SET_EMAIL_TESTING', {
        sendTestModalRef: this.$refs.sendTestDialog
      })
      this.$refs.sendTestDialog.openDialog()
    },
    onSendTestDialogOpen () {
      this.$store.commit('SET_EMAIL_TESTING_HAS_DIALOG_CLOSE', false)
      this.$store.commit('SET_SEND_TEST_MODAL_IS_OPEN', true)
    },
    onSendTestDialogClose () {
      this.$store.commit('SET_EMAIL_TESTING_HAS_DIALOG_CLOSE', true)
      this.$store.commit('SET_SEND_TEST_MODAL_IS_OPEN', false)
    },
    edit () {
      const query = { ...this.encodedUrlQuery }
      const { templateId } = query
      delete query.templateId
      if (this.template.template.editorTypeId === 1) {
        this.$router.push({ name: 'TemplateEditor', params: { id: templateId }, query: { ...this.encodedUrlQuery, isGlobal: this.template.template.isGlobal } })
      }
      if (this.template.template.editorTypeId === 2) {
        this.$router.push({ name: 'TemplateCreatorDragAndDrop', params: { id: templateId }, query: { ...this.encodedUrlQuery, isGlobal: this.template.template.isGlobal } })
      }
      if (this.template.template.editorTypeId === 3) {
        this.$router.push({ name: 'TemplateCreatorCustomCode', params: { id: templateId }, query })
      }
    },
    clone () {
      if (this.template.template.editorTypeId === 1) {
        const { templateId } = this.$route.query
        const response = this.$store.dispatch('cloneTemplate', { ...this.unencodedUrlQuery, templateId })
        response.then(({ success, error }) => {
          if (success) {
            this.$router.push({ name: 'TemplateEditor', params: { id: success.templateId }, query: this.encodedUrlQuery })
          } else if (error) {
            console.log(error)
          }
        })
      }
      if (this.template.template.editorTypeId === 2) {
        const { templateId } = this.$route.query
        const response = this.$store.dispatch('cloneTemplate', { ...this.unencodedUrlQuery, templateId })
        response.then(({ success, error }) => {
          if (success) {
            this.$router.push({ name: 'TemplateCreatorDragAndDrop', params: { id: success.templateId }, query: { ...this.encodedUrlQuery } })
          } else if (error) {
            console.log(error)
          }
        })
      }
      if (this.template.template.editorTypeId === 3) {
        const { templateId } = this.$route.query
        const response = this.$store.dispatch('cloneTemplate', { ...this.unencodedUrlQuery, templateId })
        response.then(({ success, error }) => {
          if (success) {
            this.$router.push({ name: 'TemplateCreatorCustomCode', params: { id: success.templateId }, query: { ...this.encodedUrlQuery } })
          } else if (error) {
            console.log(error)
          }
        })
      }
      const { templateId } = this.$route.query
      const response = this.$store.dispatch('cloneTemplate', { ...this.unencodedUrlQuery, templateId })
      response.then(({ success, error }) => {
        if (success) {
          this.$router.push({ name: 'TemplateEditor', params: { id: success.templateId }, query: this.encodedUrlQuery })
        } else if (error) {
          console.log(error)
        }
      })
    },
    remove () {
      const { templateId } = this.$route.query
      const response = this.$store.dispatch('deleteTemplate', { ...this.unencodedUrlQuery, templateId })
      response.then(({ success, error }) => {
        if (success) {
          this.$router.push({ name: 'TemplateBuilder', query: this.encodedUrlQuery })
        } else if (error) {
          console.log(error)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mr-3 {
  line-height: 34px;
  vertical-align: middle;
}
a#SendToTestEmails {
  &:hover {
    text-decoration: none;
  }
}
</style>
